import Vue from "vue"
import Vuex from "vuex"
import leftmenu from "./modules/leftmenu"
import maintoolbar from "./modules/maintoolbar"
import mainpage from "./modules/mainpage"
import user from "./modules/user"
import urls from "./modules/urls"
import admin from "./modules/admin";
import viewer from "./modules/viewer";
import entitled from "./modules/entitled";
import representative from "./modules/representative";
import responsible from "./modules/responsible";
import guard from "./modules/guard";
import selectors from "./modules/selectors";
import choices from "./modules/choices";
import file from "./modules/file";
import eventchain from "@/store/modules/eventchain";
import socket from "@/store/modules/socket";

Vue.use(Vuex);

const anonimusUsername = "AnonimusUser";

export default new Vuex.Store({
    modules: {
        leftmenu,
        maintoolbar,
        mainpage,
        user,
        urls,
        admin,
        viewer,
        entitled,
        representative,
        responsible,
        guard,
        selectors,
        choices,
        file,
        socket,
        eventchain
    },
    state: {
        is_mobile_view: false
    },
    getters: {
        isMobileView: state => state.is_mobile_view
    },
    actions: {
        // eslint-disable-next-line no-empty-pattern
        setIsMobileView({ commit }, {value}) {
            commit("SET_IS_MOBILE_VIEW", value)
        }
    },
    mutations: {
        SET_IS_MOBILE_VIEW: (state, value) => {
            state.is_mobile_view = value
        }
    }
})
